import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

Pusher.logToConsole = (process.env.MIX_APP_ENV != 'production') // Do not set to true on production!

window.Pusher = Pusher

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: window.pusherConfig.key,
  cluster: window.pusherConfig.cluster,
  //forceTLS: true,
})
